<template>
  <!-- 登录用户二次验证 -->
  <XModal ref="modal" v-bind="$attrs" @afterClose="afterClose" :ok="userValid" :title="title" width="300px">
    <AFormModel ref="form" :model="formData" :rules="rules">
      <AFormModelItem prop="account">
        <AInput size="large" v-model="formData.account" placeholder="请输入用户名">
          <template #prefix>
            <AIcon type="user" />
          </template>
        </AInput>
      </AFormModelItem>
      <AFormModelItem prop="password">
        <AInput size="large" v-model="formData.password" placeholder="请输入密码" type="password">
          <template #prefix>
            <AIcon type="lock" />
          </template>
        </AInput>
      </AFormModelItem>
    </AFormModel>
  </XModal>
</template>
<script>
import { validUser } from "@api"
export default {
  props: {
    title: {
      default: "用户验证"
    },
  },
  data() {
    return {
      formData: {
        account: null,
        password: null
      },
      rules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
      },
    };
  },
  computed:{
  },
  mounted(){
  },
  methods:{
    open(){
      this.$refs.modal.open()
    },
    async userValid(){
      //表单验证
      if(!await this.$refs.form.validate()){
        return false
      }
      await validUser(this.formData)
      this.$message.success("验证成功！")
      this.$emit("validSuccess")
      return true
    },
    afterClose(){
      this.formData.account = null
      this.formData.password = null
    }
  }
};
</script>
<style lang="less" scoped>
</style>
